import * as angular from "angular";
import {IController} from "angular";

export class paymentMethodsTableCtrl implements IController {

  paymentMethods: any
  defaultPaymentMethod: any
  onRemove: Function;
  onChange: Function;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('paymentMethodsTable', {
    bindings: {
      paymentMethods: '<',
      defaultPaymentMethod: '<',
      onRemove: '&',
      onChange: '&'
    },
    template: require('./payment-methods-table.html').default,
    controller: paymentMethodsTableCtrl
  });
